import { BeneficiaryViewType } from '@finxone-platform/form-action';
import {
  actionButtonNavigationConfigType,
  BeneficiaryDataContext,
  PaymentRailOptions,
  ViewType,
} from '@finxone-platform/shared/sys-config-types';
import { GetBeneficiaryResponse, UpdateBeneficiaryRequest } from '../services/account-service/account.type';

export class GetBeneficiary {
  static readonly type = '[Beneficiary] GetBeneficiary';
  constructor(
    public page = 1,
    public size = 100,
    public searchValue?: string,
    public isLoaderShown = true,
    public currency?: string,
    public viewType?: ViewType,
    public beneficiaryViewType: BeneficiaryViewType = BeneficiaryViewType.ALL_LIST,
    public dataContext?: BeneficiaryDataContext,
  ) {}
}
export class SetSelectedBeneficiary {
  static readonly type = '[Beneficiary] SetSelectedBeneficiary';
  constructor(public payload: string) {}
}

export class SetBeneficiaryLoadingStatus {
  static readonly type = '[Beneficiary] SetLoadingStatus';
  constructor(public isLoading: boolean) {}
}

export class UpdateSelectedBeneficiaryStateInfo {
  static readonly type = '[Beneficiary] UpdateSelectedBeneficiaryStateInfo';
  constructor(public beneficiaryInfo: GetBeneficiaryResponse) {}
}

export class UpdateBeneficiary {
  static readonly type = '[Beneficiary] UpdateBeneficiary';
  constructor(
    public payload: UpdateBeneficiaryRequest,
    public id: string,
    public accessToken?: string,
    public navigationConfig?: actionButtonNavigationConfigType,
    // optional callback invoked by the state action with the API response or null on failure
    public onComplete?: (response: GetBeneficiaryResponse | null) => void,
  ) {}
}
export class ClearBeneficiaryCache {
  static readonly type = '[Beneficiary] ClearBeneficiaryCache';
}

export class GetBeneficiaryRequiredFieldsAction {
  static readonly type = '[Beneficiary] GetBeneficiaryRequiredFieldsAction';
  constructor(public countryCode: string, public currencyCode: string, public scheme?: PaymentRailOptions) {}
}

export class UpdateSelectedBeneficiaryFavoriteStatus {
  static readonly type = '[Beneficiary] UpdateSelectedBeneficiaryFavoriteStatus';
  constructor(public isFavorite: boolean) {}
}

export class ToggleBeneficiaryFavouriteStatus {
  static readonly type = '[Beneficiary] ToggleBeneficiaryFavouriteStatus';
  constructor(public beneficiaryId: string, public isFavorite: boolean) {}
}
